import { trackUTMAndPromoCode } from 'actions/tracking'

export const trackClickBoxSizeExplanationBox = () =>
  trackUTMAndPromoCode('click_intro_description_box', {
    stage: 'box size',
  })
export const trackClickPostcodeExplanationBox = () =>
  trackUTMAndPromoCode('click_intro_description_box', {
    stage: 'postcode',
  })
export const trackClickDeliveryDateExplanationBox = () =>
  trackUTMAndPromoCode('click_intro_description_box', {
    stage: 'delivery date',
  })
export const trackClickPickYourRecipesExplanationBox = () =>
  trackUTMAndPromoCode('click_intro_description_box', {
    stage: 'pick your recipes',
  })
export const trackClickCreateAccountExplanationBox = () =>
  trackUTMAndPromoCode('click_intro_description_box', {
    stage: 'create account',
  })

export const trackClickContinueToBoxSize = () => trackUTMAndPromoCode('click_continue_to_boxsize')
